module.exports = __webpack_public_path__ + "static/media/Patrik_Billgert_Resume.90015a23.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/links/Patrik_Billgert_Resume.pdf
// module id = 66
// module chunks = 0